import { html, LitElement, css, unsafeCSS } from 'lit';
import styles from './progressCircle.scss?inline';
import { ATTRIBUTES, GEOMETRY } from './constants';

export default class SotbitProgressCircle extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        currentStep: { type: Number, attribute: ATTRIBUTES.CURRENT_STEP },
        totalSteps: { type: Number, attribute: ATTRIBUTES.TOTAL_STEPS },
    };

    constructor() {
        super();

        this.currentStep = 0;
        this.totalSteps = 1;
        this.circumference = 2 * Math.PI * GEOMETRY.RADIUS;
    }

    render() {
        const total = this.totalSteps > 0 ? this.totalSteps : 1;
        const current = Math.max(0, Math.min(this.currentStep, total));

        const offset = this.circumference - (current / total) * this.circumference;

        const fgCircleStyle = `
      stroke-dasharray: ${this.circumference};
      stroke-dashoffset: ${offset};
    `;

        return html`
            <div class="progress-circle-container">
                <svg class="progress-circle" viewBox="0 0 120 120">
                    <circle
                        class="progress-circle-shape progress-circle-bg"
                        cx="60"
                        cy="60"
                        r="${GEOMETRY.RADIUS}"
                    ></circle>
                    <circle
                        class="progress-circle-shape progress-circle-fg"
                        style="${fgCircleStyle}"
                        cx="60"
                        cy="60"
                        r="${GEOMETRY.RADIUS}"
                    ></circle>
                </svg>
                <div class="progress-text">${this.currentStep}/${this.totalSteps}</div>
            </div>
        `;
    }
}
